import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// A record card in a side panel over the list (the list stays where it was).
// Full screen on a phone, a column on the right from `sm` up. Closes with Esc,
// the × or a click outside; "‹" goes back to the card this one was opened from.
//   pestanas: [{ id, label }] (optional) with pestana / onPestana
//   encabezado: what goes under the title (route, chips); acciones: buttons on the right
export default function ComercialPanel({
  titulo, encabezado, acciones, pestanas, pestana, onPestana, onCerrar, onAtras, cargando, children,
}) {
  const { t } = useTranslation('comercial')

  useEffect(() => {
    // A Comercial modal open over the panel (marked data-comercial-modal) takes Esc first.
    const onKey = (e) => {
      if (e.key !== 'Escape' || document.querySelector('[data-comercial-modal]')) return
      onCerrar()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCerrar])

  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-black/20"
      onMouseDown={e => { if (e.target === e.currentTarget) onCerrar() }}>
      <aside role="dialog" aria-label={titulo || t('panel.ficha')}
        className="w-full sm:max-w-xl h-full bg-white shadow-2xl flex flex-col">
        <header className="px-4 sm:px-6 pt-4 pb-3 border-b border-gray-100">
          <div className="flex items-start gap-2">
            {onAtras && (
              <button type="button" onClick={onAtras} title={t('panel.atras')} aria-label={t('panel.atras')}
                className="shrink-0 -ml-1 w-8 h-8 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 text-lg leading-none">‹</button>
            )}
            <div className="min-w-0 flex-1">
              <h2 className="text-lg font-semibold text-gray-900 leading-tight break-words">
                {cargando ? <span className="text-gray-400">{t('panel.cargando')}</span> : titulo}
              </h2>
              {encabezado && <div className="mt-1.5">{encabezado}</div>}
            </div>
            {acciones && <div className="shrink-0 flex items-center gap-2">{acciones}</div>}
            <button type="button" onClick={onCerrar} title={t('panel.cerrar')} aria-label={t('panel.cerrar')}
              className="shrink-0 w-8 h-8 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 text-xl leading-none">×</button>
          </div>
          {pestanas?.length > 1 && (
            <div role="tablist" className="mt-3 -mb-3 flex gap-1 overflow-x-auto">
              {pestanas.map(p => (
                <button key={p.id} type="button" role="tab" aria-selected={pestana === p.id} onClick={() => onPestana(p.id)}
                  className={`shrink-0 px-3 py-2 text-sm border-b-2 -mb-px ${pestana === p.id
                    ? 'border-gray-900 text-gray-900 font-medium' : 'border-transparent text-gray-500 hover:text-gray-800'}`}>
                  {p.label}
                </button>
              ))}
            </div>
          )}
        </header>
        <div className="flex-1 min-h-0 overflow-y-auto px-4 sm:px-6 py-4">{children}</div>
      </aside>
    </div>
  )
}
